module.exports = __webpack_public_path__ + "img/bkex_s.d404f349.png";